// Copied from V1

// Example POST method implementation:
export function postFetchWrapper (url = '', data = {}, dataType = 'application/json') {
  return baseFetchWrapperWithBody('POST', url, data, dataType)
}

export function putFetchWrapper (url = '', data = {}, dataType = 'application/json') {
  return baseFetchWrapperWithBody('PUT', url, data, dataType)
}

function baseFetchWrapperWithBody (method, url, data, dataType) {
  const token = document.querySelector('meta[name="csrf-token"]').content
  // Default options are marked with *
  const response = window.fetch(url, {
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: dataType,
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': token
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    keepalive: true, // https://css-tricks.com/send-an-http-request-on-page-exit/
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
  return response // parses JSON response into native JavaScript objects
}

export function getFetchWrapper (url = '') {
  return baseFetchWrapperWithoutBody('GET', url)
}

export function deleteFetchWrapper (url = '') {
  return baseFetchWrapperWithoutBody('DELETE', url)
}

function baseFetchWrapperWithoutBody (method, url = '') {
  const token = document.querySelector('meta[name="csrf-token"]').content
  // Default options are marked with *
  const response = window.fetch(url, {
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': token
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    keepalive: true, // https://css-tricks.com/send-an-http-request-on-page-exit/
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer' // no-referrer, *client
  })
  return response // parses JSON response into native JavaScript objects
}

export function formDataFetch (formElement, url = null) {
  const requestUrl = url || formElement.action
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content

  return window.fetch(requestUrl, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': csrfToken },
    keepalive: true,
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: new FormData(formElement)
  })
}
